import Header from './components/Header';
import Hero from './components/Hero';
import SectionsA from './components/SectionsA';
import SectionsB from './components/SectionsB';
import SectionsC from './components/SectionsC';
import SectionsD from './components/SectionsD';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionsA />
        <SectionsB />
        <SectionsC />
        <SectionsD />
      </main>
      <Footer />
    </div>
  );
}